import { Container, Row, Col } from '@geberit/gdds';

// styles
import styles from '../text-image.module.scss';

// types
import type { InRowProps } from '..';

// utils
import { fullGridSize, contentHeadline, aboveHeadline } from '..';
import { buildSize, gridSizes } from 'utils/gridSize';

export function InRow(props: Readonly<InRowProps>) {
  const {
    hasVideos,
    hasImages,
    image: ImageVideo,
    headline: Headline,
    caption: Caption,
    content: Content,
    link: Link,
    theme,
  } = props;

  return (
    <Container maxContentWidth={buildSize(gridSizes[fullGridSize[theme]])}>
      <Row>
        <Col size={[12]}>{Headline && <Headline aboveHeadline={aboveHeadline[theme]} />}</Col>
      </Row>
      {hasImages && (
        <Row className={styles.centeredCol}>
          <Col size={[12]}>
            <div className={styles.inRowImages}>{ImageVideo && <ImageVideo onlyImages />}</div>
          </Col>
        </Row>
      )}
      {hasVideos && (
        <Row className={styles.centeredCol}>
          <Col size={[12]}>
            <div className={styles.inRowVideos}>{ImageVideo && <ImageVideo onlyVideos />}</div>
          </Col>
        </Row>
      )}
      {Caption && (
        <Row>
          <Col size={[12]} className={styles.fullColMargin}>
            <Caption />
          </Col>
        </Row>
      )}
      {Headline && (
        <Row>
          <Col size={[12]}>
            <Headline className={styles.subline} format={contentHeadline[theme]} />
          </Col>
        </Row>
      )}
      {Link && (
        <Row>
          <Col size={[12]}>
            <Link />
          </Col>
        </Row>
      )}
      {Content && (
        <Row>
          <Col size={[12]}>
            <Content />
          </Col>
        </Row>
      )}
    </Container>
  );
}
